import {
  AWAITING_DOCUMENTS_FROM_CITIZEN,
  APPROVED_AWAITING_COLLECTION,
  INITIAL_SUBMIT,
  PHOTOFORREFERRAL,
  RESUBMITTED,
  TEMPORARILY_SAVED,
} from "../../../constants";

import { Card, CardContent, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { FieldArray, useFormikContext } from "formik";
import useLocale from "../../../hooks/useLocale";

import { sortOrderDocs } from "../../../utils/sortOrderDocuments";

import FileUploadAdmin from "./FileUploadAdmin";
import handleImageUpload from "../../../pages/external user/editApplication/handleImageUpload";
import handleFileUpload from "../../../pages/external user/editApplication/handleFileUpload";
import { fetchApplicationDocumentsExternalUser } from "../../../services/applicationDocuments";
import { useMutation, useQuery } from "react-query";

import { Buffer } from "buffer";
import { fileUpload } from "../../../services/documentsService";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
  },
  cardContent: {
    marginTop: 15,
    marginBottom: 15,
  },
  documentsWrapper: {},
  uploadButton: {
    margin: "1rem 0",
  },
  button: {
    margin: "1rem",
  },
});

const UploadedDocumentsAdmin = React.memo(
  ({ docsPerKind, disableAll, status, initiallyUploadedDocuments, id }) => {
    const { t } = useLocale();
    const classes = useStyles();
    const [uploadedDocumentsIds, setUploadedDocumentsIds] = useState([]);
    const [imageFormatErrorText, setImageFormatErrorText] = useState("");
    const [documents, setDocuments] = useState([]);
    // const { values } = useFormikContext();
    const [values, setValues] = useState([]);
    const [reload, setReload] = useState(false)
    const [error, setError] = useState("");
    // const { id } = 845;


    const { data: documentsext, isLoading, refetch } = useQuery(
      ["applicationDocumentsWithIdExternalUser", id],
      () => fetchApplicationDocumentsExternalUser(id)
    );




    useEffect(() => {
      refetch();
      const documentsext_ = documentsext;
      setValues(documentsext_);
      // console.log("*******************");
      // console.log(id);
      // console.log(docsPerKind);
      // console.log(documentsext);

      setUploadedDocumentsIds(
        documentsext?.map((doc) => doc.doc_id)
      );

      setDocuments([]);
      let documentsH = [];
      // console.log("*******************");
      for (let i = 0; i < docsPerKind.length; i++) {

        const item = documentsext_.find(item => item.doc_id === docsPerKind[i].doc_id);

        // if (documents.find(item => item.doc_id === docsPerKind[i].id) !== null) {
        if (item === undefined) {
          // console.log("-----");
          // console.log(item);
          // console.log(docsPerKind[i]);
          // setDocuments([...documents, docsPerKind[i]]);
          documents.push(docsPerKind[i]);
          documentsH.push(docsPerKind[i]);
        }





      }
      // console.log(documentsH);
      setDocuments(documentsH);
      // console.log("*******************");
      // console.log(values.uploadedDocuments);

    }, [documentsext, reload]);





    const docsPerKindSorted = sortOrderDocs(documents);



    // const [file, setFile] = useState(null);

    // const onFileUpload = async () => {
    //   const formData = new FormData();
    //   formData.append('file', file);

    //   try {
    //     const response = await axios.post('http://localhost:5000/upload', formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data'
    //       }
    //     });
    //     console.log('File uploaded successfully', response.data);
    //   } catch (error) {
    //     console.error('Error uploading file', error);
    //   }
    // };


    const { mutate } = useMutation(fileUpload, {
      onSuccess: (data) => {
        setReload(!reload);
        setError(t(""));
      },
      onError: (error) => {
        switch (error) {
          default: {
            setReload(!reload);
            setError(t("A network error occured. Please try again later"));
          }
        }
      },
    });

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    const onFileUpload = async (file, code) => {
      const filedata = await toBase64(file);
      console.log("***** code");
      console.log(file);
      const valuesToSend = {
        // file: file,
        fidid: code.id,
        appl_kind_id: code.appl_kind_id,
        doc_id: code.doc_id,
        appl_id: id,
        filedata: filedata,
        filename: file.name,
        contentType: file.type,
      };

      mutate({ items: JSON.stringify([valuesToSend]) });
      // setReload(!reload);

      // const formData = new FormData();
      // formData.append('file', file);

      // fileUpload(file, id, code);

    };

    return (
      <Card className={classes.card}>
        <CardContent className={classes.cardContainer}>
          <FieldArray
            name="uploadedDocuments"
            render={(arrayHelpers) => (
              <div className={classes.documentsWrapper}>
                {docsPerKindSorted?.map((docPerKind, index) => {
                  // console.log(doc);
                  // This finds the uploaded document that corresponts with the
                  // current docPerKind
                  const currentDocument = documents?.find(
                    (doc) => doc?.doc_id === docPerKind.doc_id
                  );

                  // console.log(doc);

                  const initialDocument = initiallyUploadedDocuments?.find(
                    (doc) => doc?.doc_id === docPerKind.doc_id
                  );

                  const isPhoto =
                    docPerKind?.document.includes(PHOTOFORREFERRAL);

                  const error =
                    initialDocument?.reason_txt ||
                    (imageFormatErrorText && isPhoto && imageFormatErrorText) ||
                    (docPerKind.req_flg === 1 &&
                      !uploadedDocumentsIds?.includes(docPerKind.id) &&
                      t("Required"));

                  {
                    /* const disabled = !(
                    disableAll ||
                    status === RESUBMITTED ||
                    status === INITIAL_SUBMIT ||
                    status === TEMPORARILY_SAVED ||
                    (initialDocument?.sts_flg === 2 && !currentDocument)
                  ); */
                  }
                  const disabled = false;
                  /* // console.log(values.uploadedDocuments); */

                  const disabledDoc = () => {
                    // return false;
                    if (status == APPROVED_AWAITING_COLLECTION) {
                      return true;
                    } else {
                      return false;
                    }
                  }


                  return (
                    <Card
                      key={docPerKind.id}
                      variant="outlined"
                      className={classes.cardContent}
                    >
                      <CardContent>
                        <FileUploadAdmin
                          label={`${index + 1}. ${docPerKind.dscr}`}
                          document={currentDocument}
                          accept={
                            isPhoto ? "image/*" : "application/pdf,image/jpeg"
                          }
                          hint={isPhoto && t("Photo Requirements")}
                          errorLabel={error}
                          handleViewFile={() => {
                            if (currentDocument.new) {
                              const blob = new Blob(
                                [currentDocument?.files[0]],
                                {
                                  type: currentDocument?.files[0].type,
                                }
                              );

                              let url = window.URL.createObjectURL(blob);

                              window.open(url, "_blank");
                            } else {
                              if (currentDocument?.doc_data?.data) {
                                const blob = new Blob(
                                  [
                                    Buffer.from(
                                      currentDocument?.doc_data?.data
                                    ),
                                  ],
                                  {
                                    type: "application/pdf",
                                  }
                                );
                                let url = window.URL.createObjectURL(blob);

                                window.open(url, "_blank");
                              }
                            }
                          }}
                          handleDeleteFile={() => {


                            const foundDocIndex =
                              values?.uploadedDocuments?.findIndex(
                                (uploadedDoc) =>
                                  uploadedDoc.doc_id === docPerKind.doc_id
                              );

                            arrayHelpers.remove(foundDocIndex);
                          }}
                          onChange={(e) => {
                            console.log("onChange");
                            console.log(docPerKind);
                            console.log(e);
                            console.log(arrayHelpers);
                            console.log(e.target.files[0]);
                            console.log("onChange");
                            onFileUpload(e.target.files[0], docPerKind);


                            // isPhoto
                            //   ? handleImageUpload(
                            //     e,
                            //     values,
                            //     docPerKind,
                            //     setImageFormatErrorText,
                            //     arrayHelpers,
                            //     t
                            //   )
                            //   :
                            //   handleFileUpload(
                            //     e,
                            //     values,
                            //     docPerKind,
                            //     arrayHelpers
                            //   )
                          }
                          }
                          // disableViewButton={!currentDocument}
                          disableViewButton={true}
                          disabled={disabledDoc()}
                          disableDeleteButton={!currentDocument?.new && initialDocument?.sts_flg !== 2}
                          uploadedFilename={values?.uploadedDocuments
                            ?.filter((doc) => doc.doc_id === docPerKind.doc_id)
                            ?.map((doc) => {
                              if (!doc.new) {
                                return (
                                  <p key={doc.file_name}>{doc.file_name}</p>
                                );
                              } else {
                                return doc.files.map((file) => (
                                  <p key={file.name}>{file.name}</p>
                                ));
                              }
                            })}
                        />
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            )}
          />
        </CardContent>
      </Card>
    );
  }
);

export default UploadedDocumentsAdmin;
